import { render, staticRenderFns } from "./AnesthesiaChoiceQuestionType.vue?vue&type=template&id=1691e248&scoped=true"
import script from "./AnesthesiaChoiceQuestionType.vue?vue&type=script&setup=true&lang=js"
export * from "./AnesthesiaChoiceQuestionType.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AnesthesiaChoiceQuestionType.vue?vue&type=style&index=0&id=1691e248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1691e248",
  null
  
)

export default component.exports